mobileSize = 1000;

function placeTicketBtn() {
  setTimeout(() => {
    if ($('body').hasClass('saffireMobileSize')) {
      $('.ticket').appendTo('.header-bottom .inner-container');
    } else {
      $('.ticket').insertBefore('.mobile-nav-toggle');
    }
  }, 1500)
}

function removeButtonClass() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.footerItems1 a').removeClass('button');
  }
}

$(document).ready(function () {
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1000) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1001) {
    $('body').removeClass('saffireMobileSize');
  }

  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
  $('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Ticket Button
  placeTicketBtn();

  // Email Signup
  $('.footer .emailSignup .emailSignupText')
    .addClass('footer-heading')
    .text('Get the latest');
  $('.footer .emailSignup .emailSubmitButton').text('Subscribe');
  $('.footer .emailSignup .textbox')
    .attr('value', 'Email Address:')
    .attr('onclick', 'ClearDefaultText(this, "Email Address:")');
});

$(window).load(function () {
  $('body').addClass('pageIsLoaded');
  $('.tickets-fix').clone().appendTo('.container-ticket');

  // Remove Button Class
  removeButtonClass();
});

$(window).resize(function () {
  // Ticket Button
  placeTicketBtn();

  // Remove Button Class
  removeButtonClass();
});